import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export interface PasswordTooLongErrorProps {
    errorMessage?: string;
}

export const PasswordTooLongError = ({
    errorMessage,
}: PasswordTooLongErrorProps) => {
    const { t } = useTranslation();
    return (
        <Alert data-testid="kratos-password-error" severity="error">
            {errorMessage || t('formErrors.kratosPasswordError.tooLong')}
        </Alert>
    );
};
